import { PartnerSettingValue } from '@provision/entity-types';
import { useMemo } from 'react';
import { isSettingsEnabled, useGroupRules, usePartnerSettings } from 'src/graphql';
import { EntityRulesData, RULES_MAP_PER_VIEW_ENTITY } from 'src/graphql/entities/custom-view';
import { EntityNames } from 'src/graphql/types';
import { CUSTOM_VIEW_ENTITY_LABELS } from 'src/pages/CustomViews/constants';
import { useGlobalStore } from 'src/store';

const TABS: ({
  label: string;
  entity: EntityNames;
  enabled?: boolean;
} & EntityRulesData)[] = [
  {
    label: CUSTOM_VIEW_ENTITY_LABELS[EntityNames.Conversation],
    entity: EntityNames.Conversation,
  },
  {
    label: CUSTOM_VIEW_ENTITY_LABELS[EntityNames.Site],
    entity: EntityNames.Site,
  },
  {
    label: CUSTOM_VIEW_ENTITY_LABELS[EntityNames.Client],
    entity: EntityNames.Client,
  },
  {
    label: CUSTOM_VIEW_ENTITY_LABELS[EntityNames.Project],
    entity: EntityNames.Project,
  },
].map((i) => ({ ...i, ...RULES_MAP_PER_VIEW_ENTITY[i.entity] }));

export const useSearchTabs = () => {
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  const { data: partnerSettings } = usePartnerSettings({ partnerId: selectedPartnerId });
  const { loading, checkValidity } = useGroupRules();

  const tabs = useMemo(() => {
    if (loading) return [];

    return TABS.filter(({ allowedRules, disallowedPartnerSettings }) => {
      const rulesMatch = !allowedRules || checkValidity(allowedRules);

      if (!rulesMatch) {
        return false;
      }

      const settingsDisallowMatch =
        disallowedPartnerSettings?.some((settingId) =>
          partnerSettings.some((data) =>
            isSettingsEnabled(settingId, data as PartnerSettingValue),
          ),
        ) ?? false;

      return !settingsDisallowMatch;
    });
  }, [checkValidity, loading, partnerSettings]);

  return { tabs, loading };
};
